/*
  Сообщение после разговора - карточка на странице звонка (§3.5, §3.5.5).

  🔴 Вид выбран владельцем 02.10.2026 из трёх макетов, вариант Б: отдельная
  карточка под путём по шагам. Заведена после живого звонка, где человек
  попросил прислать расшифровку, сообщение не ушло - а страница об этом
  молчала: причина жила только в журнале сервера.

  Два правила кабинета, на которых она держится:

  1. **Причина отказа приходит с сервера.** Клиент её не сочиняет и не
     пересказывает: это та же строка, что записана при попытке.
  2. **Проверочный текст назван проверочным.** «Сообщение ушло» без оговорки
     было бы неправдой: ссылки человек не получил.
*/

import { Link } from 'react-router-dom'

import { dateTime } from '../api/format.js'
import { Tag } from './Common.jsx'

const WITHIN_CALL = 'по просьбе в разговоре'

const TEST_NOTE = 'включена тестовая рассылка: вместо текста со ссылкой ушёл проверочный'

const NOT_SENT = {
  failed: 'не ушло',
  unknown: 'неизвестно, ушло ли',
}

function joined(parts) {
  return parts.filter(Boolean).join(' · ')
}

function Sent({ message }) {
  const isTest = message.status === 'test'
  return (
    <>
      {message.text ? <p className="sms">{message.text}</p> : null}
      <div className="muted">
        {joined([
          message.template_title ? `формулировка «${message.template_title}»` : null,
          message.when ? dateTime(message.when) : null,
          message.outcome_title,
          isTest ? TEST_NOTE : WITHIN_CALL,
        ])}
      </div>
      {message.message_id ? (
        <p className="muted">
          <Link to={`/communications/${message.message_id}`}>Открыть сообщение отдельно</Link>
        </p>
      ) : null}
    </>
  )
}

function NotSent({ message }) {
  return (
    <>
      <div className="row">
        <Tag kind="warn">{NOT_SENT[message.status]}</Tag>
        <span className="muted">
          {joined([WITHIN_CALL, message.when ? dateTime(message.when) : null])}
        </span>
      </div>
      {message.reason ? <div className="aftercall__reason">{message.reason}</div> : null}
    </>
  )
}

export default function AfterCallMessage({ message }) {
  const went = message.status === 'sent' || message.status === 'test'
  return (
    <div className="card">
      <div className="section__title">Сообщение после разговора</div>
      {went ? <Sent message={message} /> : <NotSent message={message} />}
    </div>
  )
}
